import Hourglass from '../../assets/coming_soon/hrglasses.webm';

import styles from './ComingSoonBadge.module.scss';

const ComingSoonBadge = ({ className }: { className?: string }) => {
  const classNames = [styles['coming-soon-badge'], className];

  return (
    <div className={classNames.join(' ')}>
      <video className={styles['animation']} loop muted playsInline autoPlay preload="auto">
        <source src={Hourglass} type="video/webm" />
      </video>
      <p>Coming soon</p>
    </div>
  );
};

export default ComingSoonBadge;
